<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc1"><a href="#/ack">Acknowledgements</a></p>
<p class="toc2"><a href="#/intro">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">Lucy Keyes: The Lost Child of Wachusett</a></p>
<p class="toc2"><a href="#/chapter02">Which Rock Is Witch Rock?</a></p>
<p class="toc2"><a href="#/chapter03">William Blackstone</a></p>
<p class="toc2"><span href="#/chapter04" title="Link target outside of Sample">Phineas G. Wright</span></p>
<p class="toc2"><span href="#/chapter05" title="Link target outside of Sample">The Darn Man’s Eternal Circuit</span></p>
<p class="toc2"><span href="#/chapter06" title="Link target outside of Sample">The Indian Ghost of Hannah Frank</span></p>
<p class="toc2"><span href="#/chapter07" title="Link target outside of Sample">What Is a Yankee Doodle?</span></p>
<p class="toc2"><span href="#/chapter08" title="Link target outside of Sample">New England’s First Witch Execution</span></p>
<p class="toc2"><span href="#/chapter09" title="Link target outside of Sample">The Curse of Micah Rood’s Apples</span></p>
<p class="toc2"><span href="#/chapter10" title="Link target outside of Sample">The Legend of the Kennebunk Inn</span></p>
<p class="toc2"><span href="#/chapter11" title="Link target outside of Sample">A Cemetery with No Bodies?</span></p>
<p class="toc2"><span href="#/chapter12" title="Link target outside of Sample">The Saco River’s Undying Curse</span></p>
<p class="toc2"><span href="#/chapter13" title="Link target outside of Sample">New England’s Only Stigmatist</span></p>
<p class="toc2"><span href="#/chapter14" title="Link target outside of Sample">The Magic of the Eddys</span></p>
<p class="toc2"><span href="#/chapter15" title="Link target outside of Sample">The Devil in New England</span></p>
<p class="toc2"><span href="#/chapter16" title="Link target outside of Sample">What Does Webster Lake’s Real Name Mean?</span></p>
<p class="toc2"><span href="#/chapter17" title="Link target outside of Sample">Ramtail: The Untold Story</span></p>
<p class="toc2"><span href="#/chapter18" title="Link target outside of Sample">Rebecca Cornell’s “Unhappie Accident of Fire”</span></p>
<p class="toc2"><span href="#/chapter19" title="Link target outside of Sample">The Unfortunate Hannah Robinson</span></p>
<p class="toc2"><span href="#/chapter20" title="Link target outside of Sample">The East Thompson Stone Chamber</span></p>
<p class="toc2"><span href="#/chapter21" title="Link target outside of Sample">Two Taverns in One</span></p>
<p class="toc2"><span href="#/chapter22" title="Link target outside of Sample">The First Airplane Stolen in Vermont</span></p>
<p class="toc2"><span href="#/chapter23" title="Link target outside of Sample">Portsmouth’s Strange Discovery</span></p>
<p class="toc2"><span href="#/chapter24" title="Link target outside of Sample">Bailey’s Mills/Spite Cemetery</span></p>
<p class="toc2"><span href="#/chapter25" title="Link target outside of Sample">Lovecraft and New England</span></p>
<p class="toc2"><span href="#/chapter26" title="Link target outside of Sample">The Capture of Annawon</span></p>
<p class="toc1"><span href="#/bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc2"><span href="#/author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?12c7aff5